import { useEffect, useState } from 'react';
import { produceAPI } from '@/lib/api';

/**
 * The clusters / associations this farmer manages (the support team
 * assigns them in /admin). [] for everyone else. Fetched once per
 * signed-in user and shared by the header badge, the home card and the
 * profile.
 */
const requests = new Map(); // user id -> Promise<cluster[]>

export default function useManagedClusters(user) {
  const isFarmer = user?.user_type === 'farmer';
  const userId = user?.id;
  const [clusters, setClusters] = useState([]);
  useEffect(() => {
    if (!isFarmer || !userId) return undefined;
    let live = true;
    if (!requests.has(userId)) {
      requests.set(userId, produceAPI.myClusters()
        .then((res) => res.data.clusters.map((c) => c.cluster))
        .catch(() => { requests.delete(userId); return []; }));
    }
    requests.get(userId).then((list) => { if (live) setClusters(list); });
    return () => { live = false; };
  }, [isFarmer, userId]);
  return isFarmer ? clusters : [];
}
